import { render, staticRenderFns } from "./PropertySiteDevelopment.vue?vue&type=template&id=3bec62c7&"
import script from "./PropertySiteDevelopment.vue?vue&type=script&lang=js&"
export * from "./PropertySiteDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./PropertySiteDevelopment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports